import { Tenant as TenantType } from 'types';

export const SCOPES = {
    OPENID: 'openid',
    PROFILE: 'profile',
    USER_READ: 'User.Read'
};

export const REQUEST_SCOPES = {
    LOGIN: {
        scopes: [SCOPES.OPENID, SCOPES.PROFILE, SCOPES.USER_READ]
    }
};

export const thresholds = {
    BATTERY_LEVEL_LOW: 2900,
    CONNECTION_RATIO_LOW: 0.5,
    CONNECTION_RATIO_MEDIUM: 0.8,
    SENSOR_TYPE_ID_DETACHED: 7,
    SENSOR_TYPE_ID_INVALID: 6,
    SENSOR_TYPE_VALID: 3
};

export const colorVariants = {
    SUCCESS: 'green',
    DANGER: 'red',
    WARNING: 'orange',
    PRIMARY: 'ecp',
    SECONDARY: 'gray'
};

export enum TenantId {
    mary = 'mary',
    lucy = 'lucy',
    tork = 'tork',
}

export enum Key {
    ESCAPE = 'Escape'
}

export const tenantInfo: Record<string, Omit<TenantType, 'id'>> = {
    [TenantId.mary]: {
        name: 'SmartCare Professional'
    },
    [TenantId.lucy]: {
        name: 'SmartCare Family'
    },
    [TenantId.tork]: {
        name: 'Tork Vision Cleaning'
    }
};

export const StorageKeys = {
    tablePageSize: 'table/pagesize',
    tenant: 'tenant',
    environment: 'environment',
    gatewayDetailsConnectionStatesTablePageSize:
        'gatewaydetails/connectionstates/table/pagesize',
    rangePickerGlobal: 'range-picker/global',
    rangePickerGatewayDetails: 'range-picker/gateway-details',
};
